<zef-scrollbar [maxHeight]="maxHeight">
  <div class="__scroll-inner">

    <!-- running -->
    @if (state.runningProcesses?.length) {
      <ng-template [ngTemplateOutlet]="runningProcesses"></ng-template>
    }

    @if (state.runningProcesses?.length && state.displayedPendingProcesses?.length) {
      <ng-template [ngTemplateOutlet]="separator"></ng-template>
    }

    <!-- pending -->
    @if (state.displayedPendingProcesses?.length) {
      <ng-template [ngTemplateOutlet]="pendingProcesses"></ng-template>
    }

    @if (state.displayedPendingProcesses?.length < state.pendingProcesses?.length) {
      <ng-template [ngTemplateOutlet]="button"></ng-template>
    }

  </div>
</zef-scrollbar>

<!-- TEMPLATES -->

<ng-template #button>
  <div
    class="__button-wrap">
    <button
      class="c-button c-button--smaller"
      (click)="showAllPendingProcesses$.next($event)"
      type="button"
      mat-button>

      <mat-icon>keyboard_arrow_down</mat-icon>

      <span>Show all queued processes</span>

    </button>
  </div>
</ng-template>

<ng-template #separator>
  <zui-separator
    class="__separator-main"
    [position]="'start'"
    [size]="'small'"
    [spacing]="'none'">
  </zui-separator>
</ng-template>

<ng-template #runningProcesses>
  <div class="__running">
    <div
      *ngFor="let item of state.runningProcesses; let last = last; trackBy: trackById;"
      class="c-processes-card-item __item __item--running"
      [class.is-last]="last">
      <zui-process-item
        [translations]="processItemTranslations"
        [data]="item"
        [makeContentScrollable]="makeContentScrollable"
        [pipelineErrors]="state.pipelineErrors"
        (pipelineDetailClicked)="pipelineDetailClicked.emit($event)"
        (buildCancelClicked)="buildCancelClicked.emit($event)"
        (internalLinkClicked)="internalLinkClicked.emit()">
      </zui-process-item>
    </div>
  </div>
</ng-template>

<ng-template #pendingProcesses>
  <div
    class="__pending-wrap"
    [class.has-faded-items]="!!highlightId">

    <div
      class="c-processes-card-item  __item  __item--pending"
      [class.is-last]="last"
      [class.is-highlighted]="highlightId === item.id"
      *ngFor="let item of state.displayedPendingProcesses; let last = last; trackBy: trackById; "
      [class.is-loading]="!!processCancelProgressesMap[item.id]">
      <zui-process-item
        [translations]="processItemTranslations"
        [data]="item"
        [hideCancel]="hideCancel"
        (cancelClicked)="cancelClicked.emit($event)"
        (internalLinkClicked)="internalLinkClicked.emit()">
      </zui-process-item>
    </div>
  </div>
</ng-template>
